import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import Tooltip from '@material-ui/core/Tooltip'
import SelectList from '../../SelectList'
import SelectDishes from '../../SelectDishes'
import general from '../../../helpers/general'

export default function SideDishesSelector({
	categories,
	sideDishes,
	selectedSideDishes,
	setSelectedSideDishes,
	sideDishesLabel,
}) {
	const [categorySideDishes, setCategorySideDishes] = useState([])
	const [copyCategorySideDishes, setCopyCategorySideDishes] = useState([])
	const [categoryUpdate, setCategoryUpdate] = useState(false)

	const label = sideDishesLabel || 'Side Dishes'

	const transformCategories = () => {
		if (!categories || categories.length === 0) return []
		return categories.map((cat) => ({ value: cat._id, label: cat.name }))
	}

	const extractDishIDsFromCategory = (catIDs) => {
		if (!catIDs) return []
		const cats = categories.filter((cat) => catIDs.includes(cat._id))
		const dishes = cats.flatMap((cat) => cat?.dishes || [])
		return [...new Set(dishes.map((dish) => dish._id))]
	}

	const checkIfDishesMatchAnyCategory = () => {
		const matched = categories
			.filter((category) =>
				category.dishes.length > 0 &&
				selectedSideDishes.length > 0 &&
				category.dishes.every((dish) => selectedSideDishes.includes(dish._id))
			)
			.map((category) => ({ value: category._id, label: category.name }))
		setCategorySideDishes(matched)
	}

	const handleCategorySideDishes = (data) => {
		if (!data) data = []

		if (data.length < categorySideDishes.length) {
			const dataValues = data.map((d) => d.value)
			const categorySideDishesValues = categorySideDishes.map((cat) => cat.value)
			const diff = general.arr_diff(dataValues, categorySideDishesValues)
			const dishesToRemove = extractDishIDsFromCategory(diff)
			setSelectedSideDishes(selectedSideDishes.filter((dish) => !dishesToRemove.includes(dish)))
		} else {
			setCategorySideDishes(data || [])
			let categoryDishes = []
			if (categories.length > 0 && data.length > 0) {
				data.forEach((d) => {
					categories.forEach((cat) => {
						if (d.value === cat._id) {
							categoryDishes.push(...cat.dishes.map((dish) => dish._id))
						}
					})
				})
			}
			categoryDishes = [...new Set([...categoryDishes, ...selectedSideDishes])]
			setSelectedSideDishes(categoryDishes)
			checkIfDishesMatchAnyCategory()
		}
		setCategoryUpdate(true)
	}

	const addToSelect = (id) => {
		const temp = [...selectedSideDishes]
		temp.includes(id) ? temp.splice(temp.indexOf(id), 1) : temp.push(id)
		setSelectedSideDishes(temp)
	}

	useEffect(() => {
		// Synchronize selectedSideDishes and categorySideDishes
		if (copyCategorySideDishes.length > categorySideDishes.length) {
			const ccsd = copyCategorySideDishes.map((c) => c.value)
			const csd = categorySideDishes.map((c) => c.value)
			const diff = general.arr_diff(ccsd, csd)
			const catToRemove = categories
				.filter((cat) => cat._id === diff[0])
				.map((cat) => cat._id)
			if (catToRemove.length > 0 && categoryUpdate) {
				const dishesToRemove = extractDishIDsFromCategory(catToRemove)
				setSelectedSideDishes(selectedSideDishes.filter((dish) => !dishesToRemove.includes(dish)))
			}
		}
		setCopyCategorySideDishes(categorySideDishes)
		//eslint-disable-next-line
	}, [selectedSideDishes, categorySideDishes])

	useEffect(() => {
		checkIfDishesMatchAnyCategory()
		setCategoryUpdate(false)
		//eslint-disable-next-line
	}, [selectedSideDishes])

	if (!sideDishes || sideDishes.length === 0) return null

	return (
		<Form.Group>
			<div className="d-flex" style={{ width: '100%' }}>
				<Form.Label>Add Upsells by Category ({label})</Form.Label>
				<Tooltip
					title="Selecting a Category will add all its menu items as upsells. If you add all the individual items in a category, this field will update to list that category as having been added."
					enterTouchDelay={0}
				>
					<span
						style={{
							fontSize: 9,
							color: 'inherit',
							width: 20,
							height: 20,
							border: 'solid 1px',
							borderRadius: '50%',
							marginLeft: 15,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						className="fas fa-info"
					></span>
				</Tooltip>
			</div>
			<SelectList
				placeholder={`Select ${label.toLowerCase()} categories...`}
				isMulti={true}
				value={categorySideDishes}
				options={transformCategories()}
				onChange={(data) => handleCategorySideDishes(data)}
			/>
			<Form.Label style={{ marginTop: '10px' }}>
				Add Individual Upsells ({label})
			</Form.Label>
			<SelectDishes
				addToSelect={addToSelect}
				selectedDishes={selectedSideDishes}
				dishes={sideDishes}
			/>
		</Form.Group>
	)
}
